import React from 'react'

import { SendOutlined } from '@ant-design/icons'
import { Input } from 'antd'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const TextFieldWrapper = styled(`div`)({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  margin: `0 auto`,
})
export type ChatComponentProps = {
  sendMessage: () => void
  setMessage: (msg: string) => void
  message: string
}

export const TextInput: React.FC<ChatComponentProps> = ({
  sendMessage,
  setMessage,
  message,
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'components.meeting',
  })

  return (
    <>
      <TextFieldWrapper>
        <Input.Search
          placeholder={t('textField')}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onSearch={sendMessage}
          enterButton={<SendOutlined />}
        />
      </TextFieldWrapper>
    </>
  )
}
